import * as React from 'react';
import { Config } from '@cian/config';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';

import {
  Authentication,
  AuthenticationNext,
  createContext,
  EEventType,
  ESentEmailType,
  IAuthenticationContext,
  Provider,
} from '@cian/authentication-widget';
import { trackShow } from './tracking';

interface IProps {
  config: Config;
  httpApi: IHttpApi;
  logger: ILogger;
  // tslint:disable-next-line:no-any
  authService: any;
}

interface IAppState {
  authContext: IAuthenticationContext;
}

export class AuthWidget extends React.Component<IProps, IAppState> {
  public constructor(props: IProps) {
    super(props);

    const { httpApi, logger, config } = props;

    this.state = {
      authContext: createContext({
        httpApi,
        logger,
        subdomain: config.get<string>('subdomain') || 'www',
      }),
    };
  }

  public componentDidMount(): void {
    this.state.authContext.on(EEventType.AuthenticateSucceed, this.authenticationSucceed);
    this.state.authContext.on(EEventType.RegisterSucceed, this.handleRegisterSucceed);
    this.state.authContext.on(EEventType.SocialAuthenticateSucceed, this.handleSocialAuthenticateSucceed);
    this.state.authContext.on(EEventType.EmailSentClosed, this.handleEmailSentClosed);
    trackShow();
  }

  public componentWillUnmount(): void {
    this.state.authContext.off(EEventType.AuthenticateSucceed, this.authenticationSucceed);
    this.state.authContext.off(EEventType.RegisterSucceed, this.handleRegisterSucceed);
    this.state.authContext.off(EEventType.SocialAuthenticateSucceed, this.handleSocialAuthenticateSucceed);
    this.state.authContext.off(EEventType.EmailSentClosed, this.handleEmailSentClosed);
  }

  public render() {
    const { config } = this.props;
    const isNew =
      config.get<boolean>('qa.phone.auth.enabled') ||
      config.get<boolean>('phone.authentication.enabled');

    const disabledSocials = this.props.config.get<string[]>('authentication.disabledSocials') || [];

    return (
      <Provider context={this.state.authContext}>
        {isNew ? (
          <AuthenticationNext
            autoFocusDisabled
            disabledSocials={disabledSocials}
            userAgent={window.navigator.userAgent}
          />
        ) : (
          <Authentication disabledSocials={disabledSocials} stepFlow />
        )}
      </Provider>
    );
  }

  public handleSocialAuthenticateSucceed = ({ isNewUser }: { isNewUser: boolean }) => {
    if (!isNewUser) {
      this.authenticationSucceed();
    }
  }

  public handleRegisterSucceed = ({ isSms }: { isSms: boolean }) => {
    if (isSms) {
      this.authenticationSucceed();
    }
  }

  public handleEmailSentClosed = ({ type }: { type: ESentEmailType }) => {
    if (type === ESentEmailType.Registration) {
      this.authenticationSucceed();
    }
  }

  public authenticationSucceed = () => {
    this.props.authService.getUserData();
  }
}
